
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hotelSlug]/bookings/[id]/additional-information",
      function () {
        return require("private-next-pages/[hotelSlug]/bookings/[id]/additional-information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hotelSlug]/bookings/[id]/additional-information"])
      });
    }
  